export const aboutServices = [
  {
    label: 'Tutoring',
    href: '/our-services/tutoring-service'
  },
  {
    label: 'Mentorship',
    href: '/our-services/mentorship'
  },
  {
    label: 'Career Guidance',
    href: '/our-services/career-guidance'
  },
  {
    label: 'Job Application Assistance',
    href: '/our-services/job-application-assistance'
  },
  {
    label: 'Bursary Application Assistance',
    href: '/our-services/bursary-application-assistance'
  },
  {
    label: 'University Application Assistance',
    href: '/our-services/university-application-assistance'
  }
];

export const coreValues = [
  {
    title: 'Excellence',
    description: 'We strive to provide top-tier educational services to students.'
  },
  {
    title: 'Growth',
    description: 'We foster intellectual growth through personalized learning experiences.'
  },
  {
    title: 'Support',
    description: 'We are committed to guiding students throughout their academic journey.'
  }
];
